import script from "./BetFeedbackModals.vue?vue&type=script&setup=true&lang=js"
export * from "./BetFeedbackModals.vue?vue&type=script&setup=true&lang=js"

import "./BetFeedbackModals.vue?vue&type=style&index=0&id=78a68100&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a68100"]])

export default __exports__